module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUBAMAAAANaGKIAAAALVBMVEXBAADFERHHFxfQPz/TTU3VUVHaZ2fjjY3ml5fqqKjvv7/55eX55+f++fn///+h5mw9AAAAMklEQVQY02N4BwUTGJAAkP/UHIvgIzZMwV0LWVbdQxdsAJLniBLEqh2rRdidhOn4YQcAOOJCaynsmtQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/to.png
// module id = 398
// module chunks = 0